import React from 'react';

const RekomendasiKaryawanKeluar = () => {
  return (
    <h1>Rekomendasi Karyawan Keluar</h1>
  );
};

export default RekomendasiKaryawanKeluar;





